module.exports = __webpack_public_path__ + "img/icon-02.faf406e5.png";